import React from "react";
import { Box, Typography, Button, useTheme, Grid } from "@mui/material";
import SubHeader from "../../../../../components/SubHeader";
import CustomerList from "./CustomerList";
import styles from "./style";
import { ReactComponent as Graph } from "../../../../../assets/AccountingModule/Group 159.svg";
import { useAlert } from "../../../../../context/AlertContext";
import { useNavigate } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
// import CircularIndeterminate from "../../../../../utils/Alert/LoginAlert";
const CustomerPage = ({
  data,
  total,
  page,
  setPage,
  handleDelete,
  handleFilter,
}) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const handleNavigate = (item) => {
    navigate("/dashboard/addNewCustomer", { state: { item } });
  };

  const handleNavigateReport = (item) => {
    navigate("/dashboard/salesReport", { state: { item } });
  };

  const { showAlert } = useAlert();

  const handleAlert = () => {
    showAlert("Development In Progress", "success");
  };

  const handleNavigates = () => {
    handleAlert();

    // navigate("/dashboard/customerStatement", {
    //   state: {
    //     customerList: data,
    //   },
    // });
  };

  return (
    <>
      {/* {loader && <CircularIndeterminate/>} */}
      <Box
        px="15px"
        pt="20px"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography variant="h5" sx={styles.heading}>
          Manage Customers
        </Typography>

        <Box
          display="flex"
          justifyContent={{ xs: "start", md: "end" }}
          alignItems={{ xs: "start", md: "end" }}
        >
          <Button
            variant="contained"
            color="success"
            sx={styles.checkinBtn}
            onClick={handleNavigates}
          >
            + Statement
          </Button>
          <Button
            variant="contained"
            color="success"
            sx={styles.checkoutBtn}
            onClick={() => handleNavigate()}
          >
            + Add Customer
          </Button>
        </Box>
      </Box>
      <Grid container sx={styles.gridContainer}>
        <Grid item xs={12} lg={6.7} sx={styles.gridbox}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Box>
              <Typography sx={styles.reportHeading}>
                Sales (This Month)
              </Typography>
            </Box>
            <Box sx={{ display: "flex" }}>
              <Box sx={styles.greenDot}></Box>
              <Typography sx={styles.purchase}>Sales</Typography>
            </Box>
          </Box>
          <Box sx={styles.graph}>
            <Graph />
          </Box>
          <Box sx={styles.reportGrid}>
            <Typography
              sx={styles.reportText}
              onClick={() => handleNavigateReport()}
            >
              View Report <ArrowForwardIcon />
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} lg={5.1} sx={styles.gridbox}>
          <Box>
            <Typography sx={styles.reportHeading}>Today’s Report</Typography>
            <Box>
              <Box sx={styles.grid}>
                <Box sx={styles.keySec}>
                  <Typography sx={styles.key}>Sales</Typography>
                </Box>
                <Box sx={styles.keySec}>
                  <Typography sx={styles.key}>Orders</Typography>
                </Box>
              </Box>
              <Box sx={styles.grid}>
                <Box sx={styles.keySec}>
                  <Typography sx={styles.value}>455</Typography>
                </Box>
                <Box sx={styles.keySec}>
                  <Typography sx={styles.value}>5</Typography>
                </Box>
              </Box>
              <Box sx={styles.grid}>
                <Box sx={styles.keySec}>
                  <Typography sx={styles.key}>Purchase</Typography>
                </Box>
                <Box sx={styles.keySec}>
                  <Typography sx={styles.key}>Orders</Typography>
                </Box>
              </Box>

              <Box sx={styles.grid}>
                <Box sx={styles.keySec}>
                  <Typography sx={styles.value}>500</Typography>
                </Box>
                <Box sx={styles.keySec}>
                  <Typography sx={styles.value}>5</Typography>
                </Box>
              </Box>
              <Box sx={styles.grid}>
                <Box sx={styles.keySec}>
                  <Typography sx={styles.key}>Total Balance</Typography>
                </Box>
              </Box>

              <Box sx={styles.grid}>
                <Box sx={styles.keySec}>
                  <Typography sx={styles.value}>5</Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
      <Box
        sx={{
          backgroundColor: theme.palette.white.main,
          m: 2,
          borderRadius: "20px",
        }}
      >
        <SubHeader
          title="Customers"
          search={true}
          sortBy={true}
          onchange={(e) => handleFilter(e)}
          filter={handleAlert}
          isShowFilter={true}
          handleSort={(e) => handleFilter("", e)}
        />

        <CustomerList
          page={page}
          total={total}
          setPage={setPage}
          data={data}
          handleDelete={handleDelete}
        />
      </Box>
    </>
  );
};

export default CustomerPage;
